module.exports = __webpack_public_path__ + "static/media/S1N5-1.49a681b7.svg";